import React from "react";
import { Navigate } from "react-router";
import { useAuth } from "../../context";

const PublicRoutes = ({ children }) => {
  const { accessToken } = useAuth();
  if (accessToken) {
    // user is not authenticated
    return <Navigate to={"/"} />;
  }
  return children;
};

export default PublicRoutes;
